export const API_URI = process.env.REACT_APP_API_ENDPOINT + '/atelier'

export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL
export const SOL_WEB_URL = process.env.REACT_APP_SOL_WEB_URL

export const version = process.env.REACT_APP_VERSION || ''
export const commitSha = process.env.REACT_APP_COMMIT_SHA || ''

export const storageVersion = process.env.REACT_APP_STORAGE_VERSION || ''

export const versionString = version + (commitSha ? ` (${commitSha})` : '')
console.log(`Sol Atelier v${versionString}`)
